import React, { useState } from 'react'
import schoolLogo from '../../Assets/founder1.jpg'
import schoolLogo2 from '../../Assets/founder2.jpeg'
import { useNavigate } from 'react-router-dom'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import Container from 'react-bootstrap/Container'
import './AdminHeader.css'
import { NavDropdown } from 'react-bootstrap'
import { Modal } from 'antd'

const AdminHeader = () => {
  const navigate = useNavigate()
  const [showConfirm, setShowConfirm] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false) // mobile menu
  const [memberDropdown, setMemberDropdown] = useState(false) // dropdown

  const handleLogout = () => {
    sessionStorage.clear() // ✅ Clear session storage
    navigate('/') // ✅ Navigate to homepage
  }

  return (
    <div>
      <div className="top-header">
        <img src={schoolLogo} alt="Left Logo" className="school-logo" />
        <h1 className="school-title">श्री वारणा विद्यालय, वारणानगर</h1>
        <img src={schoolLogo2} alt="Right Logo" className="school-logo1" />
      </div>

      <Navbar
        expand="lg"
        style={{ backgroundColor: '#ffb10a', paddingBottom: '15px' }}
      >
        <Container fluid>
          <Navbar.Brand href="#"></Navbar.Brand>
          <Navbar.Toggle
            aria-controls="navbarScroll"
            style={{ backgroundColor: 'rgb(233,224,227)' }}
          />
          <Navbar.Collapse id="navbarScroll">
            <Nav className="ms-auto" navbarScroll>
              <Nav.Link href="/#/admin/dashboard" className=" mx-2">
                Dashboard
              </Nav.Link>

              <NavDropdown
                id="basic-nav-dropdown"
                className=" mx-2"
                title={<span className="my-auto">Members</span>}
              >
                <NavDropdown.Item
                  href="/#/admin/pending-reg-fee"
                  className="dropdown-item"
                >
                  Reg. Pending List
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="/#/admin/app-pending-reg-fee"
                  className="dropdown-item"
                >
                  Reg. Approval Pending List
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="/#/admin/app-reg-fee"
                  className="dropdown-item"
                >
                  Reg. Approved List
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link
                onClick={() => setShowConfirm(true)}
                className=" mx-2 pe-5 me-5"
              >
                Logout <span className="logout-arrow">→</span>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* CONFIRM LOGOUT MODAL */}
      <Modal
        title="Confirm Logout"
        open={showConfirm}
        onCancel={() => setShowConfirm(false)}
        onOk={handleLogout}
        okText="Yes, Logout"
        cancelText="Cancel"
      >
        <p>Are you sure you want to logout?</p>
      </Modal>
    </div>
  )
}

export default AdminHeader
